import { colors } from "../../utils/colors";

const baseChartContainer = {
  height: 100,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const operationsDashboardStyles = {
  container: {
    display: "flex",
    flexDirection: { xs: "column", md: "row", sm: "column" },
    gap: { xs: 2, md: 2 },
    pl: { xs: 2, md: 3 },
    pr: { xs: 2, md: 3 },
    pb: { xs: 2, md: 3 },
    pt: 1,
  },

  flex1: {
    flex: 1,
  },

  filterSection: {
    bgcolor: colors.white,
    borderRadius: 2,
    p: 3,
    width: {
      xs: "auto",
      sm: "auto",
      md: "12.5rem",
      lg: "12.5rem",
      xl: "12.5rem",
    },
    minWidth: {
      xs: "auto",
      sm: "auto",
      md: "12.5rem",
    },
    maxWidth: {
      xs: "100%",
      sm: "100%",
      md: "12.5rem",
    },
    flexShrink: 0,
    padding: "0.75rem",
  },

  filterSectionCollapse: {
    overflow: "hidden",
    position: "absolute",
    right: "0.75rem",
    top: "0.75rem",
    maxWidth: "1.5rem !important",
    height: "1.25rem",
    p: 0,
    cursor: "pointer",
    zIndex: 1,
  },

  sectionTitle: {
    fontWeight: 600,
    mb: 3,
    color: "#1a1a1a",
    fontSize: "1rem",
    marginBottom: "0rem",
  },

  dateRangeText: {
    fontSize: "0.75rem",
    fontWeight: 400,
    marginBottom: "0.3125rem",
    color: colors.grayish_blue,
  },

  contentSection: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 2,
    pb: 0,
    mb: {
      xs: 0,
      sm: 0,
      md: "1.5rem",
    },
  },

  dashboardTitle: {
    fontWeight: 500,
    color: colors.grayish_blue,
    fontSize: "1.5rem",
    lineHeight: "2.875rem",
  },

  legendContainer: {
    alignItems: "center",
    mr: "0.5rem",
    mb: {
      xs: "1.5rem",
      sm: "1.5rem",
      md: 0,
    },
  },

  legendContainerMobile: {
    alignItems: "center",
  },

  legendItemContainer: {
    alignItems: "center",
  },

  legendIndicator: {
    width: "0.875rem",
    height: "0.875rem",
    borderRadius: "50%",
  },

  legendText: {
    color: colors.legend_text,
    fontWeight: 400,
    display: "block",
    lineHeight: "0.625rem",
  },

  legendTextDesktop: {
    fontSize: "0.625rem",
  },

  legendTextMobile: {
    fontSize: "0.5rem",
  },

  filterIconContainer: {
    position: "relative",
    cursor: "pointer",
    alignItems: "center",
    height: "1.375rem",
    width: "1.5rem",
  },

  filterIcon: {
    height: "1.375rem",
    width: "1.5rem",
  },

  filterIconBadge: {
    position: "absolute",
    top: "0.1975rem",
    right: 1,
    width: "0.5625rem",
    height: "0.5625rem",
    backgroundColor: colors.filter_red,
    borderRadius: "50%",
  },

  legendDivider: {
    width: "0.0625rem",
    height: {
      xs: "0.625rem",
      sm: "0.625rem",
      md: "1.25rem",
      lg: "1.25rem",
      xl: "1.25rem",
    },
    backgroundColor: colors.divider_gray,
    mx: 1,
  },

  contentGrid: {
    flex: 1,
    bgcolor: colors.background_gray,
    borderRadius: 2,
    overflow: "auto",
    minHeight: "31.25rem",
  },

  headerStack: {
    p: "0.75rem",
    pt: "1.5rem",
    bgcolor: colors.white,
    borderRadius: 2,
  },

  sectionContainer: {
    bgcolor: colors.white,
    mb: "2.25rem",
  },

  sectionHeaderContainer: {
    display: "flex",
    alignItems: "flex-end",
    flexDirection: "row",
    mb: "0.625rem",
  },

  sectionTitleBox: {
    fontWeight: 600,
    color: colors.white,
    fontSize: "1.25rem",
    backgroundColor: colors.medium_gray,
    borderBottomLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    px: 2.5,
    flexShrink: 0,
  },

  sectionBorderLine: {
    borderBottom: `0.0625rem solid ${colors.border_gray}`,
    flexGrow: 1,
    height: 1,
  },

  metricCard: {
    elevation: 0,
    boxShadow: `0rem 0rem 0.1875rem ${colors.shadow_black}`,
    borderRadius: "0.25rem",
    position: "relative",
    transition: "all 0.2s ease-in-out",
    borderTop: `0.1875rem solid ${colors.transparent}`,
    WebkitTapHighlightColor: "transparent",
    userSelect: "none",
    outline: "none",
    WebkitTouchCallout: "none",
    "&:hover": {
      boxShadow: `0 0.25rem 0.75rem ${colors.shadow_black}`,
      borderColor: colors.border_hover,
      borderTop: `0.1875rem solid ${colors.transparent}`,
    },
    "&:focus": {
      outline: "none",
    },
    "&:active": {
      transform: "none",
    },
  },

  metricCardHoverEffect: {
    boxShadow: `0 0.25rem 0.75rem ${colors.shadow_black}`,
    borderColor: colors.border_hover,
    borderTop: `0.1875rem solid ${colors.hover_red}`,
  },

  metricCardContent: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    py: "0.75rem",
    px: "1rem",
  },

  statusIndicator: {
    width: "0.875rem",
    height: "0.875rem",
    borderRadius: "50%",
    position: "absolute",
    top: "0.75rem",
    right: "1rem",
  },

  cardTitle: {
    fontWeight: 600,
    color: colors.grayish_blue,
    pr: "0.5rem",
    fontSize: "0.75rem",
    mb: "0.5rem",
  },

  cardSubtitle: {
    fontWeight: 400,
    color: colors.text_gray,
    fontSize: "0.75rem",
    mb: "0.5rem",
  },

  cardTimeframe: {
    mt: "auto",
    fontSize: "0.6875rem",
  },

  valueText: {
    fontWeight: 600,
    color: colors.grayish_blue,
    lineHeight: 1.2,
    fontSize: "1.5rem",
  },

  subValueText: {
    fontWeight: 400,
    color: colors.grayish_blue,
    lineHeight: 1.2,
    fontSize: "0.875rem",
    marginLeft: "0.5rem",
  },

  unitText: {
    fontWeight: 600,
    color: colors.text_gray,
    fontSize: "1.25rem",
    textAlign: "center",
  },

  divider: {
    border: "none",
    height: "0.0625rem",
    mb: "0.75rem",
    mt: "0.75rem",
    backgroundImage: `repeating-linear-gradient(
      to right,
      ${colors.gradient_gray} 0,
      ${colors.gradient_gray} 0.6875rem,
      ${colors.transparent} 0.6875rem,
      ${colors.transparent} 1.625rem
    )`,
  },
  chartDivider: {
    border: "none",
    height: "0.0625rem",
    mt: "0.25rem",
    mb: "-0.125rem",
    backgroundImage: `repeating-linear-gradient(
      to right,
      ${colors.gradient_gray} 0,
      ${colors.gradient_gray} 0.6875rem,
      ${colors.transparent} 0.6875rem,
      ${colors.transparent} 1.625rem
    )`,
  },

  bottomSection: {
    mt: "auto",
  },

  bottomStack: {
    justifyContent: "space-between",
    alignItems: "flex-end",
  },

  comparisonContainer: {
    textAlign: "right",
  },

  headerRight: {
    ml: "auto",
    textAlign: "right",
  },

  comparisonValue: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: colors.grayish_blue,
  },

  comparisonLabel: {
    fontSize: "0.75rem",
    fontWeight: 400,
    color: colors.grayish_blue,
  },

  breakdownIndicator: {
    width: "0.625rem",
    height: "0.625rem",
    borderRadius: "50%",
    flexShrink: 0,
  },

  breakdownItem: {
    justifyContent: "space-between",
    alignItems: "center",
    mt: "0.125rem",
  },

  breakdownLabel: {
    fontSize: "0.75rem",
    fontWeight: 400,
    color: colors.grayish_blue,
  },

  breakdownComparison: {
    mb: "0.75rem",
    mt: "-0.375rem",
    fontSize: "0.75rem",
    fontWeight: 400,
    color: colors.grayish_blue,
  },
  breakdownPercentage: {
    fontSize: "0.8125rem",
    fontWeight: 400,
    color: colors.grayish_blue,
  },

  multiMetricContainer: {
    direction: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },

  multiMetricItem: {
    direction: "column",
  },

  multiMetricValueContainer: {
    display: "flex",
    alignItems: "baseline",
  },

  multiMetricValueText: {
    fontSize: "1.75rem",
    fontWeight: 700,
    lineHeight: 1,
    color: colors.grayish_blue,
  },

  multiMetricUnitText: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: colors.grayish_blue,
    ml: 0.5,
  },

  multiMetricLabelText: {
    fontSize: "0.75rem",
    fontWeight: 400,
    color: colors.grayish_blue,
    mt: 0.5,
  },

  multiMetricInfoText: {
    fontSize: "0.5625rem",
    fontWeight: 400,
    color: colors.grayish_blue,
    lineHeight: "0.875rem",
    maxWidth: "7.5rem",
  },

  multiMetricDivider: {
    mt: 3,
  },

  multiMetricComparisonContainer: {
    textAlign: "center",
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "0.25rem",
  },

  miniChart: {
    width: "100%",
  },

  noChartData: baseChartContainer,

  defaultChartType: {
    ...baseChartContainer,
    borderRadius: 1,
  },

  baseCardHeight: {
    height: "10rem",
  },

  baseCardClickable: {
    cursor: "pointer",
    WebkitTapHighlightColor: "transparent",
    tapHighlightColor: "transparent",
    userSelect: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
    outline: "none",
    WebkitTouchCallout: "none",
    "&:focus": {
      outline: "none",
    },
    "&:active": {
      transform: "none",
    },
  },

  flexCenter: {
    display: "flex",
    alignItems: "center",
  },

  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },

  flexRow: {
    display: "flex",
    flexDirection: "row",
  },

  valueRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    mt:-1.5,
  },

  textCenter: {
    textAlign: "center",
  },

  marginBottom24: {
    mb: "1.5rem",
  },

  marginTop1: {
    mt: "0.5rem",
  },

  chartTooltipText: {
    color: colors.chart_text,
    fontSize: "0.75rem",
    fontWeight: 400,
  },

  chartAxisLabel: {
    fontSize: "0.6875rem",
    color: colors.chart_gray,
    margin: "0.5rem",
  },

  chartBarRadius: {
    borderRadius: [0, "0.25rem", "0.25rem", 0],
  },

  chartBarRadiusVertical: {
    borderRadius: ["0.125rem", "0.125rem", 0, 0],
  },

  filterContainer: {
    padding: "0 2rem",
    minHeight: "2rem",
  },

  filterFieldBox: {
    pb: "0.9rem",
  },

  filterActionsBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    mt: "0.625rem",
  },

  applyButton: {
    fontSize: "0.75rem",
    maxWidth: "11.25rem",
    textTransform: "none",
    mr: "0.625rem",
    py: "0.25rem",
    px: "0.75rem",
  },

  clearButton: {
    fontSize: "0.75rem",
    textTransform: "none",
    color: colors.grayish_blue,
    borderColor: colors.grayish_blue,
    py: "0.25rem",
    px: "0.75rem",
    "&:disabled": {
      backgroundColor: colors.white,
    },
    "&:disabled:focus": {
      backgroundColor: colors.white,
    },
    "&:disabled:active": {
      backgroundColor: colors.white,
    },
  },

  monthRangePickerBox: {
    borderRadius: "0.25rem",
    padding: "0.5rem 0.75rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    backgroundColor: "white",
    fontSize: "0.875rem",
    transition: "border-color 0.2s, outline 0.2s",
  },

  clearIconButton: {
    color: colors.light_grey,
    p: 0.25,
    transition: "opacity 0.15s ease",
    opacity: 0,
  },

  expandMoreIcon: {
    color: colors.grayish_blue,
    transition: "transform 0.2s ease",
  },

  popoverBox: {
    p: 1,
    minWidth: "9rem",
    bgcolor: "white",
  },

  yearNavBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  monthsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 4rem)",
    gap: 0.5,
  },

  monthButton: {
    color: colors.grayish_blue,
    boxShadow: "none",
    border: "none",
  },

  yearText: {
    fontSize: "1rem",
  },

  filterModal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  filterModalBackdrop: {
    backgroundColor: colors.bg_grey,
  },

  filterModalContent: {
    width: "75%",
    bgcolor: "background.paper",
    borderRadius: "0.5rem",
    outline: "none",
    p: 3,
  },

  filterHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1rem",
  },

  filterCloseIcon: {
    cursor: "pointer",
    color: colors.chart_gray,
    width: "1.1rem",
    height: "1.1rem",
    "&:hover": {
      color: colors.light_black,
    },
  },
  marginRight24: { mr: "1.5rem" }
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case "success":
      return colors.success_green;
    case "warning":
      return colors.warning_orange;
    case "error":
      return colors.error_red;
    default:
      return colors.transparent;
  }
};

export const getBreakdownColors = () => [
  colors.breakdown_red,
  colors.breakdown_orange,
  colors.breakdown_green,
  colors.breakdown_red,
  colors.breakdown_purple,
];
